import { NavLink as RouterNavLink, useLocation } from 'react-router-dom';
import { Icon, type IconName } from '@/components/icons';

interface NavLinkProps {
  to: string;
  /** Typed against the registry so a renamed icon fails the build, not the page. */
  icon: IconName;
  label: string;
}

export function NavLink({ to, icon, label }: NavLinkProps) {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <RouterNavLink
      to={to}
      className={`sidebar-navItem ${isActive ? 'sidebar-navItem--active' : ''}`}
      aria-current={isActive ? 'page' : undefined}
    >
      <Icon name={icon} size={20} />
      <span>{label}</span>
    </RouterNavLink>
  );
}
